module.exports = __webpack_public_path__ + "img/nolook.935f20b8.png";